/**
 * Profile utilities for detecting incomplete or placeholder profile data.
 */

/**
 * Checks whether the user's name is the default placeholder "John Doe".
 * Matches case-insensitively and ignores extra whitespace.
 *
 * @param {object} userData - The user object from auth/localStorage/API.
 * @returns {boolean} true if the user still has the default name.
 */
export const hasDefaultProfileName = (userData) => {
  if (!userData || typeof userData !== 'object') return false;

  const firstName = String(userData.first_name || userData.firstName || '').trim();
  const lastName = String(userData.last_name || userData.lastName || '').trim();

  const fullName = `${firstName} ${lastName}`.trim().toLowerCase();

  return fullName === 'john doe';
};

/**
 * Checks whether the user is missing required profile information
 * (default name, country, or city).
 *
 * @param {object} userData - The user object from auth/localStorage/API.
 * @returns {boolean} true if the profile needs completion.
 */
export const requiresProfileCompletion = (userData) => {
  if (!userData || typeof userData !== 'object') return false;

  const missingName = hasDefaultProfileName(userData);
  const missingCountry = !(userData.country_id || userData.country);
  const missingCity = !(userData.city_id || userData.city);

  return missingName || missingCountry || missingCity;
};
